export const capitalize = (word: string): string =>
  word.replace(/^\w/, (char) => char.toUpperCase());

const lowercase = (word: string): string =>
  word.replace(/^\w/, (char) => char.toLowerCase());

const forceCapitalize = ["net", "out", "new", "all", "day"];

const abbreviations = ["url", "ai", "api"];

export const capitalizeAssociatedPress = (title: string): string =>
  capitalize(
    title
      .split(" ")
      .map((word) => {
        const lowercaseWord = word.toLowerCase();
        return abbreviations.includes(lowercaseWord)
          ? word.toUpperCase()
          : word.length < 4 && !forceCapitalize.includes(lowercaseWord)
            ? lowercase(word)
            : capitalize(word);
      })
      .join(" "),
  );
